import { yupResolver } from '@hookform/resolvers/yup'
import { TFunction } from 'i18next'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import ChangePasswordFormValues from 'src/types/forms/password/ChangePasswordFormValues'
import { object, ref, string } from 'yup'
import { PASSWORD_LENGTHS } from '../../../domain/auth/password'

const tForm = 'profile.changePassword.form'

const getResolver = (t: TFunction) =>
  yupResolver(
    object().shape({
      currentPassword: string().required(t(`${tForm}.currentPassword.required`)),

      newPassword: string()
        .required(t(`${tForm}.newPassword.required`))
        .min(
          PASSWORD_LENGTHS.MIN,
          t('password.errors.minLength', { minLength: PASSWORD_LENGTHS.MIN }),
        )
        .max(
          PASSWORD_LENGTHS.MAX,
          t('password.errors.maxLength', { maxLength: PASSWORD_LENGTHS.MAX }),
        )
        .notOneOf([ref('currentPassword')], t(`${tForm}.newPassword.differentFromCurrent`)),

      confirmPassword: string()
        .required(t(`${tForm}.confirmPassword.required`))
        .min(
          PASSWORD_LENGTHS.MIN,
          t('password.errors.minLength', { minLength: PASSWORD_LENGTHS.MIN }),
        )
        .max(
          PASSWORD_LENGTHS.MAX,
          t('password.errors.maxLength', { maxLength: PASSWORD_LENGTHS.MAX }),
        )
        .oneOf([ref('newPassword')], t(`${tForm}.confirmPassword.mustMatch`)),
    }),
  )

const useChangePasswordForm = (defaultValues: Partial<ChangePasswordFormValues> = {}) => {
  const { t } = useTranslation()
  const resolver = getResolver(t)

  const form = useForm({
    resolver,
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      ...defaultValues,
    },
    mode: 'onBlur',
  })

  return form
}

export default useChangePasswordForm
